var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 47.9998,
    r: 43.2,
    fill: "#FFD4C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2782 30.9001C24.1309 29.7877 24.9965 28.7998 26.1187 28.7998L36.2625 28.7998C36.762 28.7998 37.2403 29.001 37.5896 29.3581L39.106 30.9082C39.4553 31.2652 39.9337 31.4665 40.4331 31.4665H69.8605C70.9899 31.4665 71.8576 32.4665 71.6984 33.5847L67.1401 65.6049C67.0098 66.5199 66.2263 67.1998 65.3021 67.1998H30.7138C29.7827 67.1998 28.9956 66.5101 28.8733 65.5871L24.2782 30.9001Z",
    fill: "#FF744E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.096 40.5138C22.9396 39.397 23.8069 38.3999 24.9346 38.3999H71.0655C72.1932 38.3999 73.0604 39.397 72.9041 40.5138L69.3919 65.6008C69.2635 66.5177 68.4792 67.1999 67.5533 67.1999H28.4468C27.5209 67.1999 26.7365 66.5177 26.6082 65.6008L23.096 40.5138Z",
    fill: "#FFA270"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2413 53.6569C50.0231 53.6569 49.8462 53.8338 49.8462 54.052V58.4047C49.8462 58.6229 49.6693 58.7998 49.4511 58.7998H46.549C46.3308 58.7998 46.1539 58.6229 46.1539 58.4047V54.052C46.1539 53.8338 45.977 53.6569 45.7588 53.6569H43.9589C43.6393 53.6569 43.4519 53.2971 43.6352 53.0353L47.6764 47.2622C47.8337 47.0375 48.1665 47.0375 48.3237 47.2622L52.3649 53.0353C52.5482 53.2971 52.3609 53.6569 52.0412 53.6569H50.2413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtSave);
export default __webpack_public_path__ + "static/media/Art-Save.ec44aeac86f096d7fefe668f024fedd8.svg";
export { ForwardRef as ReactComponent };